"use client";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { signInSchema } from "@/features/auth/schemas";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { z } from "zod";
import { client } from "@/lib/auth-client";
import { resolveLoginIdentifier } from "@/lib/portal-login";
import { toast } from "sonner";
import { EyeIcon, EyeOffIcon } from "lucide-react";

export const FormSignIn = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const form = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
    resolver: zodResolver(signInSchema),
  });

  const onSubmit = async (values: z.infer<typeof signInSchema>) => {
    try {
      setLoading(true);
      const { error } = await client.signIn.email({
        // Sin arroba es el usuario de un permisionario y se convierte al correo
        // sintético con el que better-auth lo resuelve.
        email: resolveLoginIdentifier(values.email),
        password: values.password,
        callbackURL: "/dashboard",
        rememberMe: true,
      });

      if (error) {
        toast.error(error.message ?? "Error al iniciar sesión");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form {...form}>
      <form
        noValidate
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex w-full flex-col items-center justify-center gap-4 px-4 lg:px-[7rem]"
      >
        <FormField
          name="email"
          control={form.control}
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <Input
                  {...field}
                  placeholder="Usuario o correo electrónico"
                  type="text"
                  formNoValidate
                  size="lg"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          name="password"
          control={form.control}
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <div className="relative w-full">
                  <Input
                    {...field}
                    size="lg"
                    placeholder="Ingresa tu contraseña"
                    type={showPassword ? "text" : "password"}
                    className="w-full"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2"
                  >
                    {showPassword ? (
                      <EyeOffIcon className="h-4 w-4 text-gray-500" />
                    ) : (
                      <EyeIcon className="h-4 w-4 text-gray-500" />
                    )}
                  </button>
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button isLoading={loading} size={"lg"} className="w-full">
          Iniciar Sesión
        </Button>
      </form>
    </Form>
  );
};
